import React, { useEffect } from "react";

import { Container, Row, Col, Card } from "react-bootstrap";
import aboutImg from "../../assets/images/about/aboutimg.png";
import "../about/about.css";
import icons1 from "../../assets/images/icons/destination.png";
import icons2 from "../../assets/images/icons/best-price.png";
import icons3 from "../../assets/images/icons/quick.png";
import Breadcrumbs from "../../components/breadcrumbs/Breadcrumbs";
import { websiteData } from "../../utils/data";

const About = () => {
  useEffect(() => {
    document.title = `About Us | ${websiteData.company_name}`;
    window.scroll(0, 0);
  }, []);

  return (
    <>
      <Breadcrumbs title="About us" pagename="About us" />
      <section className="py-5 about_us">
        <Container>
          <Row>
            <Col md="8">
              <div className="about-content">
                <div className="about-image position-relative">
                  <img
                    src={aboutImg}
                    alt="about "
                    className="img-fluid rounded-5"
                  />
                </div>
              </div>
              <h2 className="h2 font-bold  pt-4 pb-2">
                Your brand, amplified. Your success, simplified.
              </h2>
              <p className=" mb-2">
                We don't just create content; we build intelligent tech
                solutions tailored to your unique goals. From immersive brand
                films to precision-targeted ad campaigns, our work is designed
                to captivate.
              </p>
              <p className=" mb-2">
                Our team bridges the gap between creative artistry and technical
                excellence to give you a competitive edge. We believe that every
                brand has a story worth telling and a global audience waiting to
                listen.
              </p>
              <p className=" mb-2">
                Partner with us to transform your digital presence into an
                unforgettable legacy.
              </p>
            </Col>
            <Col md="4">
              <Card className="border-0 shadow-sm rounded-3 mb-4">
                <Card.Body className="text-center">
                  <div className="d-flex justify-content-center align-item-search my-2">
                    <div className="rounded-circle bg-light shadow-sm bg-opacity-10 p-2 ">
                      <img src={icons1} alt="icon" className="img-fluid" />
                    </div>
                  </div>
                  <Card.Title className="fw-bold h5">
                    Limitless Reach
                  </Card.Title>
                  <p className="mb-2 body-text">
                    We bridge the gap between your local vision and a massive
                    global audience through smart placement.
                  </p>
                </Card.Body>
              </Card>

              <Card className="border-0 shadow-sm rounded-3 mb-4">
                <Card.Body className="text-center">
                  <div className="d-flex justify-content-center align-item-search my-2">
                    <div className="rounded-circle bg-light shadow-sm bg-opacity-10 p-2 ">
                      <img src={icons2} alt="icon" className="img-fluid" />
                    </div>
                  </div>
                  <Card.Title className="fw-bold h5">
                    Optimized Investment
                  </Card.Title>
                  <p className="mb-2 body-text">
                    We use tech to scale your production value without scaling
                    your costs.
                  </p>
                </Card.Body>
              </Card>

              <Card className="border-0 shadow-sm rounded-3 mb-4">
                <Card.Body className="text-center">
                  <div className="d-flex justify-content-center align-item-search my-2">
                    <div className="rounded-circle bg-light shadow-sm bg-opacity-10 p-2 ">
                      <img src={icons3} alt="icon" className="img-fluid" />
                    </div>
                  </div>
                  <Card.Title className="fw-bold h5">
                    Rapid Market Entry
                  </Card.Title>
                  <p className="mb-2 body-text">
                    Our agile tech stack moves you from strategy to launch in
                    record time.
                  </p>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default About;
